document.addEventListener('DOMContentLoaded', function () {
	const formContainer = document.getElementById('careerModal');
	const applyButton = document.getElementById('submit_modal');
	const closeButton = document.getElementById('close-icon');
	const applyFormButton = document.getElementById('formSubmit');
	const requiredInputs = document.querySelectorAll('#career-form input[required]');
	const concentValidation = document.getElementById('consent-validation');
	const resumeInput = document.getElementById('resume');
	const uploadButton = document.getElementById('resume-upload');
	const fileNameDisplay = document.getElementById('file-name');
	const nonceInput = document.getElementById('career-nonce-form');
	const applicationComplete = document.getElementById('application-complete');
	const completeApplicationClose = document.getElementById('complete-close');
	const completeApplocationButtonClose = document.getElementById('complete-close-button');
	const copyLink = document.getElementById('copyLink');
	const fileValidationMessage = document.getElementById('validated-file');
	const fileSizeValidationMessage = document.getElementById('validated-file-size');
	const fileExsistsValidationMessage = document.getElementById('validated-file-exsists');
	const formButton = document.getElementById('form-button');

	if (fileValidationMessage) {
		fileValidationMessage.style.display = 'none';
	}
	if (fileSizeValidationMessage) {
		fileSizeValidationMessage.style.display = 'none';
	}
	if (fileExsistsValidationMessage) {
		fileExsistsValidationMessage.style.display = 'none';
	}
	if (copyLink) {
		copyLink.addEventListener('click', () => {
			const link = copyLink.children[0].getAttribute('href');
			const tempTextarea = document.createElement('textarea');
			tempTextarea.value = link;
			document.body.appendChild(tempTextarea);
			tempTextarea.select();
			document.execCommand('copy');
			document.body.removeChild(tempTextarea);
			copyLink.children[2].style.visibility = 'visible';
			setTimeout(function () {
				copyLink.children[2].style.visibility = 'hidden';
			}, 2000);
		});
	}
	if (applicationComplete) {
		applicationComplete.style.display = 'none';
	}
	// Function to validate the file size
	function validateFileSize(fileInput) {
		const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB in bytes
		const fileSize = fileInput.files[0].size;
		return fileSize <= maxSizeInBytes;
	}

	function openPopup(event) {
		event.preventDefault();
		formContainer.style.display = 'block';
		concentValidation.style.display = 'none';
		document.body.classList.add('scroll-fix');
	}

	// Function to validate the file format
	function validateFileFormat(fileInput) {
		const allowedFormats = [
			'pdf',
			'doc',
			'docx',
			'ppt',
			'pptx',
			'jpg',
			'jpeg',
			'png',
			'gif',
			'zip',
			'webp',
		];
		const fileName = fileInput.value.toLowerCase();
		const fileExtension = fileName.split('.').pop();
		return allowedFormats.includes(fileExtension);
	}

	function validateForm() {
		let empty = true;
		const selectElement = document.getElementById('experience');
		if (selectElement) {
			const selectValue = selectElement.value;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			if (!selectValue) {
				empty = false;
			}
			if (!selectValue && !selectElement.nextElementSibling) {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				selectElement.parentNode.appendChild(text);
			} else if (selectValue && selectElement.nextElementSibling) {
				selectElement.nextElementSibling.remove();
			}
		}
		requiredInputs.forEach(function (input) {
			const checkbox = document.getElementById('consent');
			const isChecked = checkbox.checked;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			const val = input.value.trim();
			if (input.type !== 'checkbox' && input.type !== 'file' && input.nextElementSibling) {
				input.nextElementSibling.remove();
			}
			if ((val.length === 0 || typeof val === 'undefined') && input.type !== 'file') {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				input.parentNode.appendChild(text);
			}
			if (!resumeInput.files[0]) {
				fileExsistsValidationMessage.style.display = 'block';
				empty = false;
			}
			if (input.type === 'file' && resumeInput.files[0]) {
				fileExsistsValidationMessage.style.display = 'none';
				const fileFormat = validateFileFormat(resumeInput);
				const fileSize = validateFileSize(resumeInput);
				if (fileSize === false) {
					fileSizeValidationMessage.style.display = 'block';
					empty = false;
				} else {
					fileSizeValidationMessage.style.display = 'none';
				}
				if (fileFormat === false) {
					fileValidationMessage.style.display = 'block';
					empty = false;
				} else {
					fileValidationMessage.style.display = 'none';
				}
			}
			if (input.type === 'checkbox' && !isChecked) {
				empty = false;
				concentValidation.style.display = 'block';
			} else if (input.type === 'checkbox' && isChecked) {
				concentValidation.style.display = 'none';
			}
		});
		return empty;
	}

	function closePopup(event) {
		event.preventDefault();
		formContainer.style.display = 'none';
		document.body.classList.remove('scroll-fix');
	}

	function uploadFile() {
		const formdata = new FormData();
		const fileInput = document.getElementById('resume');
		const form = document.getElementById('career-form');
		const file = fileInput.files[0];
		const recaptchaToken = document.getElementById('recaptcha_token');
		formdata.append('file', file); // phpcs:ignore.
		formdata.append('name', form.first_name.value); // phpcs:ignore.
		formdata.append('lastname', form.last_name.value); // phpcs:ignore.
		formdata.append('email', form.email.value); // phpcs:ignore.
		formdata.append('mobile', form.mobile_number.value); // phpcs:ignore.
		formdata.append('experience', form.experience.value); // phpcs:ignore.
		formdata.append('nonce', nonceInput.value); // phpcs:ignore.
		formdata.append('role', form.role.value); // phpcs:ignore.
		formdata.append('location', form.location.value); // phpcs:ignore.
		formdata.append('careerid', form.careerid.value); // phpcs:ignore.
		formdata.append('toMail', form.toMail.value); // phpcs:ignore.
		formdata.append('recaptcha', recaptchaToken.value); // phpcs:ignore.
		formdata.append('action', 'career_form'); // phpcs:ignore.
		fetch(
			ajaxload_params.ajaxurl, // eslint-disable-line
			{
				method: 'POST',
				body: formdata,
			},
		)
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json(); // Parse the JSON response
			})
			.then(data => {
				if (data.success) {
					formContainer.style.display = 'none';
					applicationComplete.style.display = 'flex';
					document.body.classList.remove('scroll-fix');
				} else {
					console.error('Upload Failed:', data.message);
				}
			})
			.catch(error => {
				console.error('Error:', error);
			});
	}

	function closePopupSubmit(event) {
		event.preventDefault();
		if (validateForm() === true) {
			formButton.textContent = 'Applying...';
			formButton.setAttribute('disabled', true);
			uploadFile();
		}
	}

	if (uploadButton) {
		uploadButton.addEventListener('click', function () {
			resumeInput.click(); // Trigger the file input click event
		});
	}
	if (resumeInput) {
		resumeInput.addEventListener('change', function () {
			const selectedFile = resumeInput.files[0];
			if (selectedFile) {
				fileNameDisplay.textContent = selectedFile.name;
			} else {
				fileNameDisplay.textContent = '';
			}
		});
	}
	function closeCompletePopup(event) {
		event.preventDefault();
		applicationComplete.style.display = 'none';
		window.location.reload();
	}
	if (applyButton) {
		applyButton.addEventListener('click', openPopup);
	}
	if (closeButton) {
		closeButton.addEventListener('click', closePopup);
	}
	if (applyFormButton) {
		applyFormButton.addEventListener('click', closePopupSubmit);
	}
	if (completeApplicationClose) {
		completeApplicationClose.addEventListener('click', closeCompletePopup);
	}
	if (completeApplocationButtonClose) {
		completeApplocationButtonClose.addEventListener('click', closeCompletePopup);
	}

	grecaptcha.ready(function () { //eslint-disable-line
		grecaptcha //eslint-disable-line
			.execute(ajaxload_params.recaptchaSiteKey, { action: 'career_form' }) //eslint-disable-line
			.then(function (token) {
				const tokenInput = document.createElement('input');
				tokenInput.type = 'hidden';
				tokenInput.id = 'recaptcha_token';
				tokenInput.name = 'recaptcha_token';
				tokenInput.value = token;
				const recaptchaContainer = document.getElementById('career-recaptcha');
				if (recaptchaContainer) {
					recaptchaContainer.innerHTML = ''; // Clear existing content
					recaptchaContainer.appendChild(tokenInput);
				}
			});
	});
});
